// src/game-system/races/gnome.js
import { BaseRace } from './baseRace';

const GNOME_SUBRACES = {
  forest: {
    name: "Forest Gnome",
    description: "Stealthy woodland gnomes with innate magic",
    attributeBonuses: {
      dexterity: 1
    },
    traits: [
      {
        name: "Natural Illusionist",
        description: "You know minor illusion magic",
        effect: {
          type: "active",
          mechanics: "Cast Minor Illusion cantrip using Intelligence"
        }
      },
      {
        name: "Speak with Small Beasts",
        description: "You can communicate with small animals",
        effect: {
          type: "passive",
          mechanics: "Can communicate simple ideas with Small or smaller beasts"
        }
      }
    ]
  },
  rock: {
    name: "Rock Gnome",
    description: "Inventive gnomes with technological aptitude",
    attributeBonuses: {
      constitution: 1
    },
    traits: [
      {
        name: "Artificer's Lore",
        description: "You're skilled with magical devices",
        effect: {
          type: "passive",
          mechanics: "Double proficiency bonus on Intelligence (History) checks related to magic items, alchemical objects, or technological devices"
        }
      },
      {
        name: "Tinker",
        description: "You can create small devices",
        effect: {
          type: "active",
          mechanics: "Create tiny clockwork devices with 1 hour of work and 10 gp of materials"
        }
      }
    ]
  }
};

export class Gnome extends BaseRace {
  /**
   * @param {string} subrace - Gnome subrace name
   */
  constructor(subrace) {
    const subraceData = GNOME_SUBRACES[subrace];
    if (!subraceData) {
      throw new Error(`Invalid gnome subrace: ${subrace}`);
    }

    const config = {
      name: subraceData.name,
      description: subraceData.description,
      attributeBonuses: {
        intelligence: 2,
        ...subraceData.attributeBonuses
      },
      traits: [
        {
          name: "Gnome Cunning",
          description: "Your mind is resistant to magic",
          effect: {
            type: "passive",
            mechanics: "Advantage on Intelligence, Wisdom, and Charisma saving throws against magic"
          }
        },
        {
          name: "Darkvision",
          description: "You can see in dark conditions",
          effect: {
            type: "passive",
            mechanics: "See in dim light within 60 feet as if bright light"
          }
        },
        ...subraceData.traits
      ],
      cultures: [
        {
          name: "Gem Cutters",
          description: "Artisans specializing in gem crafting",
          bonusSkills: ["Investigation", "Jeweler's tools"],
          startingEquipment: ["Jeweler's tools", "Magnifying glass", "Gem samples"],
          traditions: [
            {
              name: "Gem Expertise",
              benefit: "Advantage on checks to identify or appraise gems"
            }
          ]
        },
        {
          name: "Tinker Guild",
          description: "Innovative creators of mechanical devices",
          bonusSkills: ["Tinker's tools", "Investigation"],
          startingEquipment: ["Tinker's tools", "Spare parts", "Notebook"],
          traditions: [
            {
              name: "Quick Fix",
              benefit: "Advantage on checks to repair small mechanical devices"
            }
          ]
        }
      ],
      size: {
        category: "Small",
        height: { min: 90, max: 100 },
        weight: { min: 16, max: 22 }
      },
      speed: 25,
      languages: {
        known: ["Common", "Gnomish"],
        bonus: 0
      }
    };

    super(config);
    this.subrace = subrace;
  }
}